import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MenuService as MenuServiceApi } from '@cemex-core/cmx-api';
import { ApplicationMenu, Menu } from '../cmx-layout/types/menu';

@Injectable()
export class MenuService {
  private rawMenuItems: ApplicationMenu[] = [];

  constructor(
    private api: MenuServiceApi,
    private translate: TranslateService,
  ) {}

  public async getMenu(): Promise<Observable<ApplicationMenu[]>> {
    this.rawMenuItems = await this.api.getMenu().toPromise();
    const keys = this.getMenuTranslationKeys(this.rawMenuItems);
    return this.translate.stream(keys).pipe(
      map((translations) => {
        return this.translateMenuItems(this.rawMenuItems, translations);
      }),
    );
  }

  public getMenuItemEndpoint(id: number): string {
    const flattenMenus: any = this.rawMenuItems.reduce((acc, current) => {
      return {
        ...acc,
        [current.menu.menuId]: current.menu,
        ...current.menu.menuItems.reduce((innerAcc, innerCurrent) => {
          return {
            ...innerAcc,
            [innerCurrent.menuId]: innerCurrent,
          };
        }, {}),
      };
    }, {});
    return flattenMenus[id].menuEndpoint;
  }

  protected getMenuTranslationKeys(menuRawItems: ApplicationMenu[]) {
    const keys: string[] = [];
    menuRawItems.forEach((menu) => {
      keys.push('views.sidebar.' + menu.applicationTitle);
      menu.menu.menuItems.forEach((item: Menu) => {
        keys.push('views.sidebar.' + item.menuTitle);
      });
    });
    return keys;
  }

  protected translateMenuItems(menuRawItems: ApplicationMenu[], translations: any): ApplicationMenu[] {
    return menuRawItems.map((menu) => {
      return {
        ...menu,
        menu: {
          ...menu.menu,
          menuTitle: translations['views.sidebar.' + menu.applicationTitle],
          menuItems: menu.menu.menuItems.map((item: Menu) => {
            return {
              ...item,
              menuTitle: translations['views.sidebar.' + item.menuTitle],
            };
          }),
        },
      };
    });
  }
}
